import React from 'react';
import {
  Button, Col, OverlayTrigger, Row, Tooltip,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import themeColors from '../../../utils/contants/theme-colors';

export default function TitlePage({
  title,
  subtitle,
  showIndietro,
  functionIndietro,
  showSchede,
  titleSchede,
  functionSchede,
  showRefresh,
  functionRefresh,
  showAdd,
  functionAdd,
  disabledAdd = false,
  showPrint,
  functionPrint,
  printTooltip,
  showSave,
  functionSave,
  disabledSave = false,
  showPreview,
  functionPreview,
  showButtonExport,
  buttonExport,
  showCompleta,
  functionCompleta,
  disabledCompleta = false,
  showAvanti,
  functionAvanti,
  showAvvia,
  functionAvvia,
  showDelete,
  titleDelete,
  functionDelete,
  showModify,
  functionModify,
  showConsolida,
  functionConsolida,
  titleConsolida,
  showGeneral,
  functionGeneral,
  isDisabledGeneral,
  iconGeneral,
  variantGeneral,
  titleGeneral,
  styleGeneral,
  showEstendi,
  functionEstendi,
  iconEstendi,
  variantEstendi,
  styleEstendi,
  showView,
  functionView,
  showAI,
  functionAI,
  imageAI,
  variantAI,
  titleAI,
  showMenuPtfa,
  functionMenuPtfa,
  showConsolidaTooltip,
  titleConsolidaTooltip,
  functionConsolidaTooltip,
  titleButtonConsolidaTooltip,
  iconButtonConsolidaTooltip,
  disabledConsolidaTooltip = false,
  variantButtonConsolidaTooltip,
  placementConsolidaTooltip,
}) {
  return (
    <div className="w-100">
      <div className={`${showMenuPtfa && 'd-flex justify-content-between align-items-center'}`}>
        {title
          ? (
            <>
              <h1>
                {' '}
                {title}
                {' '}
              </h1>
              {showMenuPtfa ? (
                <div
                  style={{
                    position: 'fixed',
                    top: '212px',
                    right: '-13px',
                    zIndex: '100',
                  }}
                >
                  <FontAwesomeIcon
                    onClick={functionMenuPtfa}
                    title="Apri/Chiudi menu gestione PTFA"
                    aria-hidden="true"
                    icon={['fas', 'circle-chevron-left']}
                    style={{
                      fontSize: '3rem',
                      color: themeColors.primary,
                      borderRight: '0px',
                    }}
                  />
                </div>
              ) : null}
            </>
          )
          : null}
      </div>
      <div className="mb-3">
        {subtitle ? (
          <h2 className="font-weight-normal lead">
            {' '}
            {subtitle}
            {' '}
          </h2>
        ) : null}
      </div>
      <Row className="position-relative mb-2">
        <Col className="col-md-4">
          {showIndietro ? (
            <Button variant="grey" className="float-left" onClick={functionIndietro}>
              {' '}
              <FontAwesomeIcon aria-hidden="true" icon={['fas', 'arrow-left']} />
              {' '}
              INDIETRO
              {' '}
            </Button>
          ) : null}
        </Col>
        <Col>
          <Row className="float-end">
            {showRefresh
              ? (
                <Col className="col-lg-auto text-end">
                  <Button variant="primary" onClick={functionRefresh}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'sync-alt']} />
                    {' '}
                    AGGIORNA
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showSchede
              ? (
                <Col className="col-lg-auto text-end">

                  <Button variant="primary" className="" onClick={functionSchede}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'file-alt']} />
                    {' '}
                    {titleSchede || 'SCHEDE'}
                    {' '}
                  </Button>
                </Col>
              ) : null}
            {showAdd
              ? (
                <Col className="col-lg-auto text-end">

                  <Button variant="primary" onClick={functionAdd} disabled={disabledAdd}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'plus']} />
                    {' '}
                    AGGIUNGI
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showPrint
              ? (
                <Col className="col-lg-auto text-end">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={(
                      <Tooltip id="print-tooltip" className={printTooltip ? '' : 'd-none'}>
                        {printTooltip}
                      </Tooltip>
                    )}
                  >
                    <Button variant="outline-secondary" onClick={functionPrint}>
                      {' '}
                      <FontAwesomeIcon aria-hidden="true" icon={['fas', 'print']} />
                      {' '}
                      STAMPA
                      {' '}
                    </Button>
                  </OverlayTrigger>
                </Col>
              )
              : null}
            {showSave
              ? (
                <Col className="col-lg-auto text-end">
                  <Button name="tasto-funzione" variant="primary" onClick={functionSave} disabled={disabledSave}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'save']} />
                    {' '}
                    SALVA
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showPreview
              ? (
                <Col className="col-lg-auto text-end">
                  <Button variant="primary" onClick={functionPreview}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'file-alt']} />
                    {' '}
                    PREVIEW
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showButtonExport
              ? (
                <Col className="col-lg-auto text-end">
                  {buttonExport}
                </Col>
              )
              : null}
            {showCompleta
              ? (
                <Col className="col-lg-auto text-end">
                  <Button variant="primary" onClick={functionCompleta} disabled={disabledCompleta}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'save']} />
                    {' '}
                    COMPLETA
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showAvanti
              ? (
                <Col className="col-lg-auto text-end">
                  <Button variant="primary" onClick={functionAvanti}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'arrow-right']} />
                    {' '}
                    AVANTI
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showDelete
              ? (
                <Col className="col-lg-auto text-end">
                  <Button variant="danger" onClick={functionDelete}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'trash-alt']} />
                    {' '}
                    {titleDelete ?? 'ELIMINA'}
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showModify
              ? (
                <Col className="col-lg-auto text-end">
                  <Button variant="primary" onClick={functionModify}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'pen-to-square']} />
                    {' '}
                    MODIFICA
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showView
              ? (
                <Col className="col-lg-auto text-end">
                  <Button variant="outline-primary" onClick={functionView}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'eye']} />
                    {' '}
                    VISUALIZZA
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showAvvia
              ? (
                <Col className="col-lg-auto text-end">
                  <Button variant="success" onClick={functionAvvia} style={{ color: 'white' }}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'play']} />
                    {' '}
                    AVVIA
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showConsolida
              ? (
                <Col className="col-lg-auto text-end">
                  <Button name="tasto-funzione" variant="primary" onClick={functionConsolida}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', 'file-pen']} />
                    {' '}
                    {titleConsolida}
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showGeneral
              ? (
                <Col className="col-lg-auto text-end">
                  <Button name="tasto-funzione" style={styleGeneral ?? {}} variant={variantGeneral ?? 'info'} onClick={functionGeneral} disabled={isDisabledGeneral}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', iconGeneral ?? 'info']} />
                    {' '}
                    {titleGeneral ?? 'Info'}
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showEstendi
              ? (
                <Col className="col-lg-auto text-end">
                  <Button style={styleEstendi ?? {}} variant={variantEstendi ?? 'info'} onClick={functionEstendi}>
                    {' '}
                    <FontAwesomeIcon aria-hidden="true" icon={['fas', iconEstendi ?? 'info']} />
                    {' '}
                    AGGIUNGI AMBITO DI RUOLO
                    {' '}
                  </Button>
                </Col>
              )
              : null}
            {showAI
              ? (
                <Col className="col-lg-auto text-end">
                  <Button style={{ display: 'flex', alignItems: 'center', gap: '8px' }} variant={variantAI ?? 'info'} onClick={functionAI}>
                    {imageAI}
                    {titleAI ?? 'Info'}
                  </Button>
                </Col>
              )
              : null }
            {showConsolidaTooltip
              ? (
                <Col className="col-lg-auto text-end" style={{ marginRight: '12px' }}>
                  <OverlayTrigger
                    placement={placementConsolidaTooltip ?? 'left'}
                    delay={{ show: 250, hide: 400 }}
                    overlay={(
                      <Tooltip id="button-tooltip" className={disabledConsolidaTooltip ? '' : 'd-none'}>
                        {titleConsolidaTooltip}
                      </Tooltip>
                    )}
                  >
                    <div>
                      <Button
                        style={{
                          display: 'flex', alignItems: 'center', gap: '8px', color: 'white',
                        }}
                        variant={variantButtonConsolidaTooltip ?? 'success'}
                        onClick={functionConsolidaTooltip}
                        disabled={disabledConsolidaTooltip}
                      >
                        {' '}
                        <FontAwesomeIcon aria-hidden="true" icon={['fas', iconButtonConsolidaTooltip ?? 'list-check']} />
                        {' '}
                        {titleButtonConsolidaTooltip ?? 'CONSOLIDA'}
                        {' '}
                      </Button>
                    </div>
                  </OverlayTrigger>
                </Col>
              )
              : null}
          </Row>
        </Col>
      </Row>
    </div>
  );
}
